import { useMutation } from "@tanstack/react-query"
import { useCallback } from "react"
import customerApis from "src/api/customer"
import { ApiResponseModel } from "src/types/common"
import { CustomerDetailRequestModel } from "src/types/customer"

const handleResponse = (res: ApiResponseModel<unknown>) => {
  if (!res || !res.Result || res.ErrorCode !== 0) return undefined
  if (Array.isArray(res.Result)) {
    return res.Result.length ? res.Result[0] : undefined
  }
  return res.Result
}

const useProfile = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (payload: CustomerDetailRequestModel) =>
      customerApis.get(payload),
  })

  const onGetProfile = useCallback(
    async (val: string) => {
      try {
        const response = await mutateAsync({ phoneNumber: val })
        return handleResponse(response)
      } catch (error) {
        return undefined
      }
    },
    [mutateAsync]
  )

  return { onGetProfile, isProfileLoading: isPending }
}

export default useProfile
